/*
(function () {
  // 目標日時 JST
  const target = new Date("2026-03-06T12:00:00+09:00").getTime();

  const dEl = document.getElementById("d");
  const hEl = document.getElementById("h");
  const mEl = document.getElementById("m");
  const sEl = document.getElementById("s");

  function update() {
    const now = Date.now();
    let diff = target - now;
    if (diff < 0) diff = 0;

    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor(diff / (1000 * 60 * 60)) % 24;
    const m = Math.floor(diff / (1000 * 60)) % 60;
    const s = Math.floor(diff / 1000) % 60;

    dEl.textContent = d;
    hEl.textContent = h;
    mEl.textContent = m;
    sEl.textContent = s;
  }

  update();
  setInterval(update, 1000);
})();
*/


//ヘッダをfixedにしていることで生じるアンカーリンクの誤差修正
//ヘッダをfixedにしていることで生じるアンカーリンクの誤差修正
$(function () {
  $('a[href^=#]').click(function() {
    var target = $(this.hash);
    if (!target.length) return ;
    var targetY = target.offset().top-80;

    $('html,body').animate({scrollTop: targetY}, 800, 'swing');

    // メニューを閉じる
    $('.hamburger, .header-nav').removeClass('is-active');

    window.history.pushState(null, null, this.hash);
    return false;
  });

  $('#close').click(function() {
    $('#navigation-2').slideUp(240);
  });

  $('#navigation-2-trigger, #navigation-2').hover(
    function() {
      $('#navigation-2').stop().slideDown(240);
    },
    function() {
      $('#navigation-2').stop().slideUp(240);
    });

  $(window).scroll(function() {
    var now = $(window).scrollTop();
    var end = $(document).height();

    // 追加：スクロールしたらハンバーガーメニュー閉じる
    $('header, .hamburger, .header-nav').removeClass('is-active');

    if (now > 480) {
      $('#page-top, #pageSsba').fadeIn(240);
    } else {
      $('#page-top, #pageSsba').fadeOut(240);
    }
  });

  $('#page-top a').hover(
    function() {
      $(this).stop().animate({ opacity : 0.64 }, 240, 'swing');
    },
    function() {
      $(this).stop().animate({ opacity : 1 }, 240, 'swing');
    });

  $('#page-top a').click(function() {
    $('html, body').animate({ scrollTop : 0 }, 800, 'swing');
  });

});

//sp menu
$('.hamburger').click(function() {
  $(this).toggleClass('is-active');
  $('.header').toggleClass('is-active');
  $('.header-nav').toggleClass('is-active');
});


//スクロール位置によるナビアクティブ切替
$(function () {

  const OFFSET = 120; // ヘッダー高さ + 余裕

  const $links = $('.header-nav__link');

  $(window).on('scroll', function () {

    const scrollPos = $(window).scrollTop();

    $('section[id]').each(function () {

      const sectionTop = $(this).offset().top - OFFSET;
      const sectionBottom = sectionTop + $(this).outerHeight();
      const id = $(this).attr('id');

      if (scrollPos >= sectionTop && scrollPos < sectionBottom) {

        $links.removeClass('is-active');

        $('.header-nav__link[href="#' + id + '"]').addClass('is-active');

      }

    });

  });

});